import { render } from "./Authorization.vue?vue&type=template&id=02539048&scoped=true"
import script from "./Authorization.vue?vue&type=script&lang=js"
export * from "./Authorization.vue?vue&type=script&lang=js"

import "./Authorization.vue?vue&type=style&index=0&id=02539048&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-02539048"

export default script